import { FC, ReactElement } from 'react'
import { useLocation } from 'react-router-dom'
import { WrapLogin } from './partials/wrap'

interface ConfirmationLinkSentProps {
  email: string
}

export const ConfirmationLinkSent: FC<ConfirmationLinkSentProps> = ({
  email,
}): ReactElement => {
  const { state } = useLocation<ConfirmationLinkSentProps>()

  return (
    <WrapLogin>
      <div className="modal-mail">
        <div className="form-logo">
          <a href="#">
            <img src="img/modal/logo-1.svg" alt="" />
          </a>
        </div>
        <p>
          Didn&apos;t receive the email? <a href="#">Send again</a>
        </p>
        <h3 className="modal-mail__title">Let’s confirm your email!</h3>s
        <p>
          Please verify your account by visiting link we sent to{' '}
          <b>{state?.email || email}</b>
        </p>
        <div className="modal-privacy">
          <div className="modal-privacy__top">
            <img src="img/modal/modal-ico.svg" alt="" />
            Your privacy is important
          </div>
          <p>
            We may send you member updates, recruiter messages, job suggestions,
            invitations, reminders and promotional messages from us and our
            partners. You can change your preferences anytime.
          </p>
        </div>
      </div>
    </WrapLogin>
  )
}
